import { render, staticRenderFns } from "./product.html?vue&type=template&id=73310913&scoped=true&"
import script from "./product.js?vue&type=script&lang=js&"
export * from "./product.js?vue&type=script&lang=js&"
import style0 from "./product.less?vue&type=style&index=0&id=73310913&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73310913",
  null
  
)

export default component.exports